import React from 'react';
import { Spacer, H1, P } from '../../ui/style';
import { sprintf, __ } from '@wordpress/i18n';
import NextStepButton from '../../components/util/next-step-button/next-step-button';
import DefaultStep from '../../components/default-step/index'
import ImagePreview from '../../components/image-preview/index';

const Welcome = () => {
	return (
		<DefaultStep
			content={
				<>
					<Spacer />
					<H1>{__('Welcome!', 'astra-sites')}</H1>
					<P>{__('In the next 5 minutes, you will have your ready website up and running!', 'astra-sites')}</P>
					<NextStepButton after>{__('Let\'s Begin', 'astra-sites')}</NextStepButton>
				</>
			}
			actions={
				<p>
					By submitting, you agree to our <a href="https://store.brainstormforce.com/terms-and-conditions/" target="_blank">Terms</a> and <a href="https://store.brainstormforce.com/privacy-policy/" target="_blank">Privacy Policy</a>
				</p >
			}
			preview={
				<ImagePreview fileName='step-1.svg' />
			}
		/>
	)
}

export default Welcome;
